
import React, { useEffect } from 'react';
import TestimonialHeader from './testimonial/TestimonialHeader';
import { useBreakpoint } from '@/hooks/use-mobile';
import SectionLayout from './SectionLayout';

const TestimonialVideos = () => {
  const { isMobile } = useBreakpoint();
  
  // Use useEffect for logging instead of doing it directly in JSX
  useEffect(() => {
    if (isMobile) {
      console.log('Mobile view active for testimonials');
    }
  }, [isMobile]);
  
  return (
    <SectionLayout 
      containerWidth="full"
      paddingY="py-6 md:py-12" 
      backgroundColor="bg-gray-50"
      containerBackgroundColor="bg-gray-50"
      className="px-0 sm:px-0 md:px-0" // Removing horizontal padding at all breakpoints
    >
      <div className="container mx-auto px-2 sm:px-4 md:px-6 max-w-6xl">
        <TestimonialHeader />
      </div>
    </SectionLayout>
  );
};

export default TestimonialVideos;
